import { Fragment, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function SessionGate({ children, allowPasswordChange = false }: { children: ReactNode; allowPasswordChange?: boolean }) {
  const { status, user, generation } = useAuth();
  const location = useLocation();
  if (status === 'unknown' || status === 'authenticating') return <div role="status" className="p-6">Loading...</div>;
  if (status !== 'authenticated') {
    const to = location.pathname + location.search + location.hash;
    return <Navigate replace to={`/login?to=${encodeURIComponent(to)}`} />;
  }
  if (user?.must_change_password && !allowPasswordChange) return <Navigate replace to="/auth/change-password" />;
  return <Fragment key={generation}>{children}</Fragment>;
}
